import { useApiQuery } from 'hooks/useApiQuery'
import { type RewardsRedemption } from 'types/api'
import { formatDateTime, removeUndefined } from 'utils/util'

export const useGetRewardsRedemptionsByTransactionDate = ({
  startDate,
  endDate,
}: {
  startDate?: string
  endDate?: string
  onSuccess?: (response: RewardsRedemption[]) => void
}) => {
  const queryArgs = removeUndefined({
    startTransactionDate: formatDateTime(startDate),
    endTransactionDate: formatDateTime(endDate),
  })

  return useApiQuery({
    path: '/admin/rewards/redemptions/transaction-date',
    method: 'get',
    queryKey: [
      '/admin/redemptions/rewards/rewards-programs/rewardsProgramId/redemptions',
      formatDateTime(startDate),
      formatDateTime(endDate),
    ],
    queryArgs,
    enabled: !!startDate && !!endDate,
  })
}
